import React from "react";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
} from "../../../../helpers/icons/fontAwesomeIcons";
import classes from "./FeaturePagination.module.scss";

const FeaturePagination = ({
  t,
  currentPage,
  totalPages,
  onPageChange,
  showPageNumbers = false, // Set default to false to hide page numbers
}) => {
  // No need to render pagination if there's only one page
  if (totalPages <= 1) return null;

  return (
    <div className={classes.paginationContainer}>
      {/* First page button */}
      <Button
        variant="outline-secondary"
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
        className={classes.paginationButton}
        title={t("first_page")}
      >
        <FontAwesomeIcon icon={faAnglesLeft} />
      </Button>

      {/* Previous page button */}
      <Button
        variant="outline-secondary"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={classes.paginationButton}
        title={t("previous_page")}
      >
        <FontAwesomeIcon icon={faAngleLeft} />
      </Button>

      {/* Page info */}
      <span
        className={classes.pageInfo}
        style={{ marginLeft: showPageNumbers ? 0 : "" }}
      >
        {currentPage}/{totalPages}
      </span>

      {/* Next page button */}
      <Button
        variant="outline-secondary"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={classes.paginationButton}
        title={t("next_page")}
      >
        <FontAwesomeIcon icon={faAngleRight} />
      </Button>

      {/* Last page button */}
      <Button
        variant="outline-secondary"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
        className={classes.paginationButton}
        title={t("last_page")}
      >
        <FontAwesomeIcon icon={faAnglesRight} />
      </Button>
    </div>
  );
};

FeaturePagination.propTypes = {
  t: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  showPageNumbers: PropTypes.bool,
};

export default FeaturePagination;
